<template>
  <InternalServerError
    v-if="serverError"
    :statusCode="serverError.status"
  />
  <NotFound v-else-if="notFound" />
  <router-view
    v-else
    :key="componentKey"
  />
  <ToastContainer
    v-if="messages.length > 0"
    :messages="messages"
  />
</template>

<script setup>
import { onMounted, provide, ref } from 'vue';
import { useRouter } from 'vue-router';
import mitt from 'mitt';
import I18n from 'i18n-js';

import ToastContainer from '@/components/generic/toast_container.vue';
import InternalServerError from '@/components/errors/internal_server_error.vue';
import NotFound from '@/components/errors/not_found.vue';

function getMeta(name) {
  return document.querySelector(`meta[name="${name}"]`)?.getAttribute('content');
}

const router = useRouter();
const emitter = mitt();
const componentKey = ref(0);

provide('currentUser', JSON.parse(getMeta('current_user')));
provide('uploadUrl', getMeta('upload_url'));
provide('eventTarget', new EventTarget());
provide('scrolling', ref(false));
provide('emitter', emitter);

const messages = ref([]);
const serverError = ref(null);
const notFound = ref(false);

/**
 * Event to display a toast notification.
 * adds to array and pops it off after some time.
 */
emitter.on('toast', (notification) => {
  messages.value.push(notification);

  setTimeout(() => {
    messages.value.shift();
  }, 3700);
});

onMounted(() => {
  I18n.locale = JSON.parse(getMeta('current_user')).locale;
});

/**
 * Event from the language selection,
 * in order to re-render the component to load I18n
 * we update the component key value.
 */
emitter.on('updateLocale', (selectedLocale) => {
  I18n.locale = selectedLocale;
  componentKey.value = componentKey.value++;
});

emitter.on('serverError', error => {
  serverError.value = error;
  let removeBeforeEach = router.beforeEach(() => {
    serverError.value = null;
    removeBeforeEach();
  });
});

emitter.on('notFound', () => {
  notFound.value = true;
  let removeBeforeEach = router.beforeEach(() => {
    notFound.value = false;
    removeBeforeEach();
  });
});

emitter.on('unauthorized', () => {
  window.location.href = '/';
});
</script>
